<ng-template #investInvitationPopup let-modal>
   <article class="article-grid modal-body border-0 p-0 position-relative">
      <button tabindex="-1" type="button" class="position-absolute top-0 end-0 p-1 p-lg-2 border-0 bg-transparent rounded-2 cls-btn" (click)="onMaybeLater(modal)">
         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 6 6 18m12 0L6 6"/>
         </svg>
      </button>
      <div class="d-none d-lg-block">
         <img *ngIf="isEuropeanUser" src="/assets/images/modal/nabil-fekir.webp" alt="invest" class="img-fluid d-block">
         <img *ngIf="!isEuropeanUser" src="/assets/images/modal/pc.webp" alt="invest" class="img-fluid d-block">
      </div>

      <div class="d-flex flex-column align-items-start justify-content-center bg-white p-3 p-lg-4" *ngIf="isLgUp || !isEuropeanUser">
         <div class="mx-lg-auto text-content-inner-wrapper">
            <h4 class="mb-0 fw-600 text-uppercase highlight-h4 text-center mt-3 mt-lg-0">
               Limited to the first <span class="clr-green">100 investors</span> only
            </h4>
            <h5 class="mb-0 fw-normal">
               Invest in Musaffa and get up to <span class="clr-green fw-600">6 years</span> of <span class="clr-green fw-600">FREE</span> halal stock trading
               <span class="fst-italic d-block value-span">(Up to <strong class="fw-600">$1,080</strong> in value)</span>
               <!-- <span *ngIf="isEuropeanUser" class="fst-italic d-block value-span">(Up to <strong class="fw-600">€936</strong> in value)</span> -->
            </h5>
            <p class="mb-0">
               Join <span class="clr-green fw-600">1,000+</span> investors who've already invested <span class="clr-green fw-600">{{ data?.total_investment_amount || '$6.74M' }}</span>
            </p>

            <!-- <div class="countdown-wrapper d-grid gap-3 p-3 br-10 text-center text-uppercase">
               <h6 class="mb-0 fw-500">Offer Ends {{ offerEndDisplay }}</h6>

               <div class="skeleton-loader height-10r br-10" *ngIf="isCountdownLoading"></div>

               <div class="countdown-timer fw-500" *ngIf="!isCountdownLoading">
                  <ng-container *ngIf="(countdown$ | async) as t; else loading">
                     <div class="time-unit d-flex flex-column align-items-center gap-1">
                        <span class="time-number lh-1">{{ t.days | number : "2.0" }}</span>
                        <span class="time-label text-uppercase">DAY</span>
                     </div>
                     <div class="time-unit d-flex flex-column align-items-center gap-1">
                        <span class="time-number lh-1">{{ t.hours | number : "2.0" }}</span>
                        <span class="time-label text-uppercase">HOUR</span>
                     </div>
                     <div class="time-unit d-flex flex-column align-items-center gap-1">
                        <span class="time-number lh-1">{{ t.minutes | number : "2.0" }}</span>
                        <span class="time-label text-uppercase">MIN</span>
                     </div>
                     <div class="time-unit d-flex flex-column align-items-center gap-1">
                        <span class="time-number lh-1">{{ t.seconds | number : "2.0" }}</span>
                        <span class="time-label text-uppercase">SEC</span>
                     </div>
                  </ng-container>

                  <ng-template #loading>
                     <div class="skeleton-loader height-10r br-10" style="grid-column: 1 / -1;"></div>
                  </ng-template>
               </div>
            </div> -->
            <footer class="mod-footer gap-2 gap-lg-3">
               <!-- <button tabindex="-1" type="button" class="d-none d-lg-block w-100 align-items-center invest-invitation-btn text-nowrap" (click)="onMaybeLater(modal)">
                  Maybe later
               </button> -->
   
               <button *ngIf="!isEuropeanUser" tabindex="-1" type="button" class="d-block w-100 align-items-center invest-invitation-btn text-nowrap filled" (click)="onInvest(modal, 'general')">
                  Invest Halal Now
               </button>

               <button *ngIf="isEuropeanUser" tabindex="-1" type="button" class="d-block w-100 align-items-center invest-invitation-btn text-nowrap filled" (click)="onInvest(modal, 'nabil_fekir')">
                  Invest Halal Now
               </button>
            </footer>
         </div>
      </div>

      <div class="d-flex flex-column align-items-start justify-content-center bg-white p-3 p-lg-4 " *ngIf="!isLgUp && isEuropeanUser">
         <div class="mx-lg-auto text-content-inner-wrapper european">
            <h4 class="mb-0 fw-600 text-uppercase highlight-h4 text-center mt-3 mt-lg-0">
               Limited to the first <span class="clr-green">100 investors</span> only
            </h4>
            <h5 class="mb-0 fw-normal text-center">
               Invest in Musaffa and get up to <span class="clr-green text-nowrap fw-600">6 years</span> of <span class="clr-green fw-600">FREE</span> halal stock trading
               <span class="fst-italic d-block value-span">(Up to <strong class="fw-600">$1,080</strong> in value)</span>
               <!-- <span *ngIf="isEuropeanUser" class="fst-italic d-block value-span">(Up to <strong class="fw-600">€936</strong> in value)</span> -->
            </h5>
            <div class="position-relative mob-nabil-fekir-wrapper">
               <img src="/assets/images/modal/nabil-fekir-mob.webp" alt="invest" class="img-fluid mx-auto d-block">
               <div class="d-flex align-items-center justify-content-center gap-1 position-absolute bottom-0 start-50 translate-middle-x w-100 mb-3 mob-disc bg-white px-2 py-3 br-10">
                  <p class="mb-0">
                     <span class="fw-600"> — Nabil Fekir, French Footballer & </span> <br>
                     <span class="">2018 FIFA World Cup Champion</span> <br>
                     <small class="d-inline-block fw-600">Major Investor & Brand Ambassador</small>
                  </p>
                  <button tabindex="-1" role="button" class="bg-transparent d-block rounded-circle outline-none border-0" placement="left" ngbTooltip="Disclaimer: Nabil Fekir is an investor in Musaffa and has signed a celebrity endorsement agreement. Compensation has been provided for appearing in the ad.">
                     <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.992 1.498c-4.125 0-7.5 3.375-7.5 7.5s3.375 7.5 7.5 7.5 7.5-3.375 7.5-7.5-3.375-7.5-7.5-7.5M9 11.998v-3.75m.008-2.246H9" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                     </svg>
                  </button>
               </div>
            </div>
            <footer class="mod-footer gap-2 gap-lg-3">
               <!-- <button tabindex="-1" type="button" class="d-none d-lg-block w-100 align-items-center invest-invitation-btn text-nowrap" (click)="onMaybeLater(modal)">
                  Maybe later
               </button> -->
   
               <button tabindex="-1" type="button" class="d-block w-100 align-items-center invest-invitation-btn text-nowrap filled" (click)="onInvest(modal, 'nabil_fekir')">
                  Invest Halal Now
               </button>
            </footer>
         </div>
      </div>
   </article>
</ng-template>